(function() { window.GUID_5024363e_a13d_4c90_bcc1_61e4303c4d68 = { getGuid: function() { return "5024363e-a13d-4c90-bcc1-61e4303c4d68"; } }; })();
var CompuSport;
(function (CompuSport) {
    class CSRequestAnimationFrame {
        Request(callback) {
            let me = this;
            if (me.inProcess) {
                return;
            }
            me.inProcess = true;
            requestAnimationFrame(function () {
                callback.call(me);
                me.inProcess = false;
            });
        }
    }
    CompuSport.CSRequestAnimationFrame = CSRequestAnimationFrame;
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=CSRequestAnimationFrame.js.map
